<template>
  <el-collapse class="r-collapse style-collapse bordered">
    <el-collapse-item
      v-for="(task, i) in tasks"
      :key="task.task_id + i"
      :name="i"
    >
      <template slot="title">
        <el-tooltip
          :open-delay="500"
          effect="dark"
          :content="getTaskHint(task.worker_class)"
          placement="top"
        >
          <div :class="getTaskImage(task.worker_class)" />
        </el-tooltip>
        <div class="tasks__block">
          <div class="tasks__title">
            <r-text type="caption" style="margin:0 8px 0 0">
              {{ $t("task:type") }}
            </r-text>
            <r-text>
              {{ $t(task.worker_class) }}
            </r-text>
          </div>
          <div class="tasks__title">
            <r-text type="caption" style="margin:0 8px 0 0">
              {{ $t("task:start_time") }}
            </r-text>
            <r-text>{{ getDate(task.start_time) }}</r-text>
          </div>
        </div>
        <div class="tasks__complete-status tasks__loader" v-if="!task.done">
          <i class="el-icon-loading" />
        </div>
        <div class="tasks__complete-status success" v-else-if="task.success">
          <i class="el-icon-success" />
        </div>
        <div class="tasks__complete-status error" v-else>
          <i class="el-icon-error" />
        </div>
      </template>
      <div class="tasks-modal__list-item_content">
        <div class="tasks-modal__list-item__info">
          <div class="tasks-modal__list-item__info-row">
            <div class="tasks-modal__list-item__info-title">
              <r-text type="caption">
                {{ $t("task:id") }}
              </r-text>
            </div>
            <div class="tasks-modal__list-item__info-description">
              <r-text>{{ task.task_id }}</r-text>
            </div>
          </div>

          <div class="tasks-modal__list-item__info-row">
            <div class="tasks-modal__list-item__info-title">
              <r-text type="caption">
                {{ $t("task:status") }}
              </r-text>
            </div>
            <div class="tasks-modal__list-item__info-description">
              <r-text>{{ $t(`task:status:${task.success}`) }}</r-text>
            </div>
          </div>

          <div class="tasks-modal__list-item__info-row">
            <div class="tasks-modal__list-item__info-title">
              <r-text type="caption">
                {{ $t("task:start_time") }}
              </r-text>
            </div>
            <div class="tasks-modal__list-item__info-description">
              <r-text>{{ getDate(task.start_time) }}</r-text>
            </div>
          </div>

          <div class="tasks-modal__list-item__info-row">
            <div class="tasks-modal__list-item__info-title">
              <r-text type="caption">
                {{ $t("task:end_time") }}
              </r-text>
            </div>
            <div class="tasks-modal__list-item__info-description">
              <r-text>{{ getDate(task.end_time) }}</r-text>
            </div>
          </div>

          <div class="tasks-modal__list-item__info-row" v-if="task.params.type">
            <div class="tasks-modal__list-item__info-title">
              <r-text type="caption">
                {{ $t("task:file_type") }}
              </r-text>
            </div>
            <div class="tasks-modal__list-item__info-description">
              <r-text>{{ task.params.type }}</r-text>
            </div>
          </div>

          <div
            class="tasks-modal__list-item__info-row"
            v-if="task.params.data_source_name"
          >
            <div class="tasks-modal__list-item__info-title">
              <r-text type="caption">
                {{ $t("task:ds_name") }}
              </r-text>
            </div>
            <div class="tasks-modal__list-item__info-description">
              <r-text>{{ task.params.data_source_name }}</r-text>
            </div>
          </div>
        </div>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import moment from "moment";
import { getTaskImage, getTaskHint } from "../../configs";

export default {
  props: {
    tasks: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  methods: {
    getDate(date) {
      return moment(date).format("HH:mm DD.MM.YYYY");
    },
    getTaskImage,
    getTaskHint
  }
};
</script>

<style lang="scss">
.tasks-modal {
  .tasks__block {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    .tasks__title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-bottom: 0;
      display: flex;
      line-height: 1.6;
      .r-text {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .tasks__complete-status {
    width: 40px;
    padding: 0;
    margin-left: auto;
    &.tasks__loader {
      margin-right: 4px;
      i {
        font-size: 16px;
      }
    }
  }
  .r-block-title {
    margin-bottom: 12px;
  }
  .tasks__no-data {
    padding: 0;
  }
  width: 500px;
  .r-collapse {
    padding-right: 4px;
    .el-collapse-item {
      padding: 4px;
      border-bottom: 1px solid !important;
      margin-bottom: 4px;
      border-color: var(--dividers_low_contrast) !important;
      &:last-child {
        margin-bottom: 0;
      }
      &:first-child {
        border-top: 1px solid !important;
      }
    }
  }
  &__active-tasks {
    margin-bottom: 12px;
  }
  &__list-item__info-row {
    display: flex;
  }
  &__list-item__info-description,
  &__list-item__info-title {
    box-sizing: border-box;
    padding: 0 4px;
    overflow: hidden;
  }
  &__list-item__info-title {
    width: 40%;
  }
  &__list-item__info-description {
    width: 60%;
  }
  .el-collapse-item__header {
    margin-bottom: 4px;
  }
}
</style>

<i18n>
{
  "ru": {
    "task:id": "ID задачи: ",
    "task:status": "Статус выполнения: ",
    "task:status:true": "Выполнена успешно",
    "task:status:false": "Произошла ошибка",
    "task:start_time": "Начало выполнения:",
    "task:end_time": "Окончание выполнения:",
    "task:type": "Тип задачи: ",
    "task:type:import_data": "Импорт данных",
    "task:file_type": "Тип файла:",
    "task:ds_name": "Название источника данных:",
    
    "GeojsonImporter": "Импорт GEOJSON",
    "DataBaseImporter": "Подключение PostgreSQL таблицы",
    "SkimMatrix": "SkimMatrix",
    "TileLayerImporter": "Импорт TileLayer",
    "DemandMatrix": "DemandMatrix",
    "StatisticsDataWriter": "StatisticsDataWriter",
    "CalculationRuner": "CalculationRuner",
    "ChsmeoCamsDataWriter": "ChsmeoCamsDataWriter",
    "LTMProcess": "Расчет LTM",
    "DataImport": "Импорт данных",
    "TestWorker": "TestWorker",
    "DueProcess": "Расчет DUE",
    "OsrmProcess": "Подготовка данных для OSRM",
    "VisumProcess": "Тестовый расчет Visum",
    "STA": "STA",
    "GdbImporter": "Импорт GDB",
    "NetImporter": "Импорт NET",
    "DueImporter": "Импорт DUE",
    "CustomImporter": "Создание пользовательского слоя",
    "CsvImporter": "Импорт CSV",
    "DmdImporter": "Импорт DMD",
    "UserImporter": "Импорт пользовательских данных",
    "JsonImporter": "Импорт JSON",
    "GtfsImporter": "Импорт GTFS",
    "ShpImporter": "Импорт SHP",
    "OsmExport": "Экспорт в OSM",
    "LtmExport": "Экспорт данных для LTM",
    "DueExport": "Экспорт данных для DUE",
    "DorfondImporter": "Импорт данных Dorfond",
    "TracksImporter": "Импорт данных трэков",
    "DnlProcess": "Расчет DNL"
  },
  "en": {
    "task:id": "Task ID: ",
    "task:status": "Task status: ",
    "task:status:true": "Success",
    "task:status:false": "Failed",
    "task:start_time": "Start time:",
    "task:end_time": "End time:",
    "task:type": "Task type: ",
    "task:type:import_data": "Import data",
    "task:file_type": "File type:",
    "task:ds_name": "Datasource name:",
    
    "GeojsonImporter": "GEOJSON import",
    "DataBaseImporter": "PostgreSQL table connecting",
    "SkimMatrix": "SkimMatrix",
    "TileLayerImporter": "TileLayer import",
    "DemandMatrix": "DemandMatrix",
    "StatisticsDataWriter": "StatisticsDataWriter",
    "CalculationRuner": "CalculationRuner",
    "ChsmeoCamsDataWriter": "ChsmeoCamsDataWriter",
    "LTMProcess": "LTM calculation",
    "DataImport": "Data import",
    "TestWorker": "TestWorker",
    "DueProcess": "DUE calculation",
    "OsrmProcess": "OSRM data preparation",
    "VisumProcess": "Visum test calculation",
    "STA": "STA",
    "GdbImporter": "GDB import",
    "NetImporter": "NET import",
    "DueImporter": "DUE import",
    "CustomImporter": "User layer creating",
    "CsvImporter": "CSV import",
    "DmdImporter": "DMD import",
    "UserImporter": "User data import",
    "JsonImporter": "JSON import",
    "GtfsImporter": "GTFS import",
    "ShpImporter": "SHP import",
    "OsmExport": "OSM export",
    "LtmExport": "LTM export",
    "DueExport": "DUE export",
    "DorfondImporter": "Dorfond import",
    "TracksImporter": "Tracks import",
    "DnlProcess": "DNL calculation"
  }
}
</i18n>
